import { render, staticRenderFns } from "./EditFlagModal.vue?vue&type=template&id=53e1605a&"
import script from "./EditFlagModal.vue?vue&type=script&lang=js&"
export * from "./EditFlagModal.vue?vue&type=script&lang=js&"
import style0 from "./EditFlagModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports